const SCHEMA_ID_PARAM_KEY = 'schemaId';
const PARENT_ID_PARAM_KEY = 'parentId';

export const fieldCreateRoute = <T extends string>(elisPathname: T) =>
  `${elisPathname}/schema/:${SCHEMA_ID_PARAM_KEY}/parent/:${PARENT_ID_PARAM_KEY}/create-field` as const;

export const getFieldTitleFromPath = (pathname: string) =>
  pathname.includes('/detail') ? pathname.split('/detail/')[1] : null;
